import api from '../lib/axios';

export const timeEntriesApi = {
  // Listar time entries de uma tarefa
  getByTask: async taskId => {
    const response = await api.get(`/time-entries/tasks/${taskId}`);
    return response.data;
  },

  // Criar nova entrada de tempo
  create: async data => {
    const response = await api.post('/time-entries', data);
    return response.data;
  },

  // Atualizar entrada de tempo
  update: async (timeEntryId, data) => {
    const response = await api.put(`/time-entries/${timeEntryId}`, data);
    return response.data;
  },

  // Deletar entrada de tempo
  delete: async timeEntryId => {
    const response = await api.delete(`/time-entries/${timeEntryId}`);
    return response.data;
  },

  // Iniciar timer
  start: async (taskId, notes = null) => {
    const response = await api.post('/time-entries/start', {
      task_id: taskId,
      notes,
    });
    return response.data;
  },

  // Parar timer
  stop: async timeEntryId => {
    const response = await api.post(`/time-entries/stop/${timeEntryId}`);
    return response.data;
  },

  // Obter timer ativo
  getActive: async () => {
    const response = await api.get('/time-entries/active');
    return response.data;
  },
};
